var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsNumber, IsOptional, IsString, IsUUID, ValidateIf } from 'class-validator';
export class CreateCustomFormElementAnswerDto {
    answer;
    index;
    customFormElementId;
}
__decorate([
    IsOptional(),
    ValidateIf((_, value) => value !== null),
    IsString(),
    __metadata("design:type", Object)
], CreateCustomFormElementAnswerDto.prototype, "answer", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], CreateCustomFormElementAnswerDto.prototype, "index", void 0);
__decorate([
    IsOptional(),
    IsUUID(),
    __metadata("design:type", String)
], CreateCustomFormElementAnswerDto.prototype, "customFormElementId", void 0);
//# sourceMappingURL=create-custom-form-element-answer.dto.js.map